import { API_URL_BASE, htmlElem } from '../utils/globals';
import { retrieveFromSessionStorage } from '../utils/utilsStorage';
import { fetchSync } from '../utils/fetchSync';

const subNavigation = () => {
    const privatePagesData = retrieveFromSessionStorage('privatePages');
    const wrapper = htmlElem.querySelector('.sub-nav');
    const parser = new DOMParser();

    [...privatePagesData].forEach(item => {
        let imageSrc;
        if (item.featured_media > 0) {
                const data = fetchSync(`${API_URL_BASE}/media/${item.featured_media}`);
                imageSrc = data.guid?.rendered;
        } else {
            const html = item.content.rendered;
            const doc = parser.parseFromString(html ?? '', 'text/html');
            imageSrc = doc.querySelector('img')?.getAttribute('src');
        }
        const template = `
            <li>
                <a href="/${item.slug}">
                    <img src=${imageSrc} />
                    <span>${item.title.rendered}</span>
                </a>
            </li>
        `;
        wrapper?.insertAdjacentHTML('beforeend', template);
    });
};

export {
    subNavigation
}